import React, { useState } from 'react';
import type { CatalogPreliminary } from '../types';

interface PreliminaryEditModalProps {
  preliminary: CatalogPreliminary | null;
  isOpen: boolean;
  onClose: () => void;
  onSave: (updated: Partial<CatalogPreliminary>) => void;
}

export const PreliminaryEditModal: React.FC<PreliminaryEditModalProps> = ({
  preliminary,
  isOpen,
  onClose,
  onSave,
}) => {
  if (!isOpen || !preliminary) return null;

  const [valueTemplate, setValueTemplate] = useState(preliminary.value_template);
  const [status, setStatus] = useState(preliminary.status);
  const [sourceType, setSourceType] = useState(preliminary.source_type);
  const [confidence, setConfidence] = useState(preliminary.confidence != null ? String(preliminary.confidence) : '');
  const [sourceRef, setSourceRef] = useState(preliminary.source_ref || '');
  const [confirmationRequired, setConfirmationRequired] = useState(preliminary.confirmation_required);
  const [notes, setNotes] = useState(preliminary.notes || '');

  const handleSave = () => {
    onSave({
      question_id: preliminary.question_id,
      service_id: preliminary.service_id,
      value_template: valueTemplate,
      status,
      source_type: sourceType,
      confidence: confidence ? parseFloat(confidence) : null,
      source_ref: sourceRef || null,
      confirmation_required: confirmationRequired,
      notes: notes || null,
      status_review: 'CHANGED',
    });
    onClose();
  };

  return (
    <div className="cov-modal-overlay" onClick={onClose}>
      <div className="cov-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="cov-modal-head">
          <div>
            <h3 style={{ margin: 0, fontSize: '1.125rem' }}>Редактирование предварительного ответа</h3>
          </div>
          <button className="cov-btn cov-btn-outline" onClick={onClose}>✕</button>
        </div>

        <div className="cov-modal-body">
          <div className="cov-form-group">
            <label className="cov-form-label">Шаблон ответа / Значение</label>
            <textarea
              className="cov-form-textarea"
              rows={3}
              value={valueTemplate}
              onChange={(e) => setValueTemplate(e.target.value)}
              placeholder="Введите предварительный ответ или оставьте пустым..."
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <div className="cov-form-group">
              <label className="cov-form-label">Статус ответа</label>
              <select
                className="cov-form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="NEEDS_CONFIRMATION">Требует подтверждения</option>
                <option value="CONFIRMED">Подтверждён</option>
                <option value="PREFILLED">Автозаполнено</option>
                <option value="OPTIONAL">Необязательно</option>
              </select>
            </div>
            <div className="cov-form-group">
              <label className="cov-form-label">Тип источника</label>
              <select
                className="cov-form-select"
                value={sourceType}
                onChange={(e) => setSourceType(e.target.value as any)}
              >
                <option value="CLIENT_IMPORTED">Импорт из заявки клиента</option>
                <option value="OWNER_FILLED">Заполнено владельцем</option>
                <option value="PROFILE">Из профиля пользователя</option>
                <option value="FILE_EXTRACTION">Извлечено из файла</option>
                <option value="SYSTEM_PREFILL">Предложенный ответ</option>
                <option value="AI_GENERATED">Подготовлено ИИ</option>
                <option value="MANUAL">Ручной ввод</option>
              </select>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <div className="cov-form-group">
              <label className="cov-form-label">Уровень уверенности (от 0 до 1)</label>
              <input
                type="number"
                step="0.05"
                min="0"
                max="1"
                className="cov-form-input"
                value={confidence}
                onChange={(e) => setConfidence(e.target.value)}
              />
            </div>
            <div className="cov-form-group">
              <label className="cov-form-label">Ссылка на источник (Source ref)</label>
              <input
                className="cov-form-input"
                value={sourceRef}
                onChange={(e) => setSourceRef(e.target.value)}
                placeholder="REQ-2026-0048, FILE-012..."
              />
            </div>
          </div>

          <div className="cov-form-group">
            <label className="cov-form-label">Внутренние примечания владельца</label>
            <textarea
              className="cov-form-textarea"
              rows={2}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8125rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={confirmationRequired}
              onChange={(e) => setConfirmationRequired(e.target.checked)}
            />
            Требовать явного подтверждения заявителем на Этапе 3
          </label>
        </div>

        <div className="cov-modal-foot">
          <button className="cov-btn cov-btn-outline" onClick={onClose}>Отмена</button>
          <button className="cov-btn cov-btn-primary" onClick={handleSave}>Сохранить</button>
        </div>
      </div>
    </div>
  );
};
